/* Feature flags — read once from `process.env` (baked in at build time
 * by Create React App / craco). Import a named constant instead of
 * touching `process.env` directly so a single edit here is enough to
 * flip a flag app-wide.
 *
 * How each flag behaves:
 *   ANY value other than the string "true" (case-insensitive) means
 *   DISABLED. Missing env var → disabled. This is intentional: we don't
 *   want a stray typo to silently ship a half-finished feature.
 *
 * ─────────────────────────────────────────────────────────────────
 * VOICE_CALLS_ENABLED
 *   Disabled by default (Feb 2026) — the Agora voice-call feature is
 *   not yet ready for App Store submission. iOS rejects apps whose
 *   voice calls don't work in background / lock-screen; fixing that
 *   requires PushKit + CallKit native integration which is out of
 *   scope for the current release. All UI touchpoints (call button
 *   in room header, calls-tab, incoming-call sheet, SSE listener,
 *   Agora pre-warm) short-circuit when this flag is false.
 *   Backend routes remain live but dormant — they get no traffic
 *   because the UI never issues start/answer calls.
 * ─────────────────────────────────────────────────────────────────
 */

const _isTrue = (v) => String(v || "").toLowerCase() === "true";

export const VOICE_CALLS_ENABLED = _isTrue(process.env.REACT_APP_ENABLE_VOICE_CALLS);
